import Endpoint from '../api/endpoint.js'
import { OK, UNAUTHORIXED, UNPROCESSABLE_ENTITY, LoginMsg, LogoutMsg, INTERNAL_SERVER_ERROR} from '../util.js'

const state = {
  user: null,
  apiStatus: null,
  loginErrorMessages: null,
  netWorkErrorMessages: null,
  hasToken: null,
}

const getters ={
  check: state => !! state.user,                              //!! ←二重否定
  super_user: state => {
    if(state.user){
      return state.user.permission.super_user ? state.user.permission.super_user : false
    }
    return false
  },
  user: state => state.user ? state.user : '',
  username: state => state.user ? state.user.username : '',
  token: state => state.hasToken ? state.hasToken : '',
  postUser: state => { return {user: state.user, token: state.hasToken}},
}

const mutations = {
  setUser(state, data){
    state.user = data.user ? data.user : null
    state.hasToken = data.token ? data.token : null
  },
  setApiStatus(state, status){
    state.apiStatus = status
  },
  setLoginErrorMessages(state, messages){
    state.loginErrorMessages = messages
  },
}

const actions = {
  /**
   * ログイン認証
   * @param {*} context 
   * @param {*} data 
   */
  async login (context, data){
    context.commit('setApiStatus', null)
    context.commit('loading/setLoadingStatus', { loading: true, message: LoginMsg }, { root: true } )

    //ログインAPI
    await Endpoint.login(data).then(response => {
      if(response.status === OK){
        //成功したらtrueを代入
        context.commit('setApiStatus', true)
        context.commit('setUser', response.data)
        context.commit('loading/clearLoading', null, { root: true } )
        return false
      }
  
      if(response.status === UNPROCESSABLE_ENTITY){
        context.commit('setLoginErrorMessages', response.data.errors)
      } else {
        //通信に失敗した場合に error モジュールの setCode ミューテーションを commit するが、あるストアモジュールから別のモジュールのミューテーションを commit する場合は第三  引数に { root: true } を追加する必要がある。
        context.commit('error/setCode', response.status, { root: true })
      }
  
      context.commit('loading/clearLoading', null, { root: true } )
    }).catch(error => {
      if(error.response.status === UNAUTHORIXED){
        //ログイン認証失敗
        context.commit('setApiStatus', false)
        context.commit('loading/clearLoading', null, { root: true } )
        context.commit('setLoginErrorMessages', error.response.data.errors)
        return false
      }
      //それ以外のエラー
      context.commit('setApiStatus', false)
      context.commit('error/setCode', INTERNAL_SERVER_ERROR, { root: true } )
      context.commit('loading/clearLoading', null, { root: true } )
      return false
    })
  },
  /**
   * ログインユーザーチェック
   * @param {*} context 
   */
  async currentUser(context){

    //tokenが保持されている場合は認証
    context.commit('setApiStatus', null)
    context.commit('loading/setLoadingStatus', { loading: true, message: LoginMsg }, { root: true } )

    //storeにtokenが保存されていない場合はそのままスルー
    if(context.getters.token === ''){
      context.commit('setUser', { user: null, token: null })
      context.commit('setApiStatus', true)
      context.commit('loading/clearLoading', null, { root: true } )
      return false
    }

    await Endpoint.auth(context.getters.postUser).then(response => {
      if (response.status === OK) {
        context.commit('setApiStatus', true)
        context.commit('setUser', response.data)
        context.commit('loading/clearLoading', null, { root: true } )
        return false
      }

      //不明なエラーが発生
      context.commit('setApiStatus', false)
      context.commit('error/setCode', response.status, { root: true })
      context.commit('loading/clearLoading', null, { root: true } )
    }).catch(function(error){
      context.commit('setUser', false)
      if(error.response.status === INTERNAL_SERVER_ERROR){
        context.commit('setApiStatus', false)  //ユーザーデータをクリアしているので/loginに飛ばされる
        context.commit('error/setCode', INTERNAL_SERVER_ERROR, { root: true } )
        context.commit('loading/clearLoading', null, { root: true } )
        return false
      }
      context.commit('setApiStatus', true)  //ユーザーデータをクリアしているので/loginに飛ばされる
      context.commit('loading/clearLoading', null, { root: true } )
      
    })
  },
  /**
   * ログアウト処理
   */
  async logout(context){
    context.commit('setApiStatus', false)
    context.commit('loading/setLoadingStatus', { loading: true, message: LogoutMsg }, { root: true } )
    context.commit('setUser', false)
    context.commit('loading/clearLoading', null, { root: true } )
    context.commit('setApiStatus', true)  //ユーザーデータをクリアしているので/loginに飛ばされる
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}